
<div class="content-container">
    <cron-editor [(options)]="cronOptions" [(cron)]="cronExpression" [formControl]="cronForm"></cron-editor>
    <div>
        <h3>
            <b>Expression: {{cronForm.value}}</b>
        </h3>
      </div>
    <div *ngIf="showButtons" class="button-container">
        <button mat-flat-button id="no-button"  [mat-dialog-close]="false" >Cancelar</button>
        <button mat-raised-button id="yes-button" color="primary" (click)="salvar()">Selecionar</button>
    </div>

</div>

